import React from "react";
import { useNavigate } from "react-router-dom";
import "../../css/components/Header.css";
import HeaderImage from "../../assets/images/ThePlanLogo.png";
import PrimaryButton from "./buttons/PrimaryButton";

const Header = () => {
  const navigate = useNavigate();

  return (
    <header
      className="main-header"
     
    >
      <div style={{ flex: 1 }}></div>
      <div
        className="header-nav"
        style={{
          flex: 2,
          display: "flex",
          justifyContent: "center",
          gap: "2rem",
        }}
      >
        <a href="/#the-plan" className="nav-regular">
          The plan
        </a>
        <a href="/#who-we-cover" className="nav-regular">
          Who we cover
        </a>
        <a href="/#about" className="nav-regular">
          About
        </a>
        <a href="/#contact" className="nav-regular">
          Contact Us
        </a>
      </div>
      <div
        className="header-logo"
        style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}
      >
        <a href="/">
          <img src={HeaderImage} alt="Oakmont Financial Services Logo" />
        </a>
      </div>
    </header>
  );
};

export default Header;
